import SportOnboarding from "./components/SportOnboarding";
import { hyroxConfig } from "./ch/sportConfig";

const Hyrox = () => {
  return <SportOnboarding sportConfig={hyroxConfig} navKey="hyrox" />;
};

export default Hyrox;
